import type { IconDefinition } from '../index.tsx';

export const iconTiktok: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconTiktok',
  icon: [
    16,
    16,
    [],
    '',
    'M14.99 6.55311C13.5857 6.58431 12.2751 6.14744 11.1517 5.3361V10.9218C11.1517 14.8225 6.90781 17.2565 3.53764 15.3218C0.167467 13.3559 0.167467 8.48784 3.53764 6.5219C4.505 5.96021 5.6596 5.74177 6.78299 5.8978V8.70627C5.0667 8.14458 3.41282 9.67364 3.78728 11.4211C4.19295 13.1686 6.31491 13.8551 7.65673 12.6381C8.12481 12.2013 8.40566 11.5772 8.40566 10.9218V0H11.1517C11.1517 0.249642 11.1517 0.468079 11.2141 0.717721C11.4014 1.7475 11.9943 2.65245 12.8992 3.21414C13.4921 3.61981 14.241 3.83825 14.99 3.83825V6.55311Z',
  ],
};
